// app/components/ThemeChanger.js
'use client';
import tcStyles from "./theme-changer-button.module.css"
import sStyles  from "./search-button.module.css"
import { useDispatch, useSelector } from "react-redux"
import { cycleTheme }   from "@lib/features/theme/themeSlice"
import { BsCircleHalf, BsMoonFill, BsSearch, BsSunFill } from "react-icons/bs"

const PREFERENCE_META = {
    system: { label: "Auto", icon: <BsCircleHalf />, next: "Light" },
    light: { label: "Light", icon: <BsSunFill />, next: "Dark" },
    dark: { label: "Dark", icon: <BsMoonFill />, next: "Auto" },
}

export function ThemeChanger() {
    const dispatch = useDispatch()
    const preference = useSelector(state => state.theme.preference)

    const changeTheme = () => {
        dispatch(cycleTheme())
    }

    const meta = PREFERENCE_META[preference] ?? PREFERENCE_META.system

    return (
        <button
            type="button"
            className={tcStyles.themeChanger}
            onClick={changeTheme}
            aria-label={`Theme: ${meta.label}. Switch to ${meta.next}`}
            title={preference === "system" ? "Auto — following system theme" : `Theme set to ${meta.label}`}
        >
            <span className={tcStyles["knob"]} aria-hidden="true">
                {meta.icon}
            </span>
            <span className={tcStyles["theme-name"]} aria-hidden="true">
                <span>{meta.label}</span> mode
            </span>
        </button>
    )
}

export function SearchButton() {
    return (
        <button type="button" className={sStyles.searchButton} aria-label="Search">
            <BsSearch />
        </button>
    )
}
